export default __webpack_public_path__ + "static/media/bin.283b9885.jpg";